module.exports = __webpack_public_path__ + "img/header-dark.084b39c.png";